import { useState } from 'react';
import styled from 'styled-components';
import { CredusText, color } from 'ui';
import { useNavigate } from 'react-router';

import { TitleDivProps } from '../../candidate-upload/components/Index';
import { TestProvider } from '../../../../contexts/TestContext';
import CreateTestModal from './modals/CreateTestModal';
import TestConfigurationModal from './modals/TestConfigurationModal';
import TestReUpLoad from './TestReUpload';
import PublishTest from './PublishTest';
import TestData from './TestData';

const TestUpload = () => {
  const [createTest, setCreateTest] = useState(false);
  const [testReUpload, setTestReUpload] = useState(false);
  const [publishTest, setPublishTest] = useState(false);
  const [configureTest, setConfigureTest] = useState(false);

  const navigate = useNavigate();

  const title = [
    {
      name: 'Candidates',
      active: false,
      route: '/test-management/candidate-upload',
    },
    { name: 'Test', active: true, route: '/test-management/test-upload' },
    { name: 'Report', active: false, route: '/test-management/report' },
  ];

  return (
    <TestProvider>
      <div>
        {configureTest && (
          <TestConfigurationModal
            configureTest={configureTest}
            setTestReUpload={setTestReUpload}
            setConfigureTest={setConfigureTest}
            setPublishTest={setPublishTest}
          />
        )}
        {testReUpload && (
          <TestReUpLoad
            setConfigureTest={setConfigureTest}
            setCreateTest={setCreateTest}
            setTestReUpload={setTestReUpload}
          />
        )}
        {publishTest && (
          <PublishTest
            setPublishTest={setPublishTest}
            setConfigureTest={setConfigureTest}
          />
        )}
        {!testReUpload && !publishTest && (
          <>
            <TabDiv>
              <Div>
                {title.map((el) => (
                  <TitleDiv
                    active={el.active}
                    onClick={() => navigate(el.route)}
                  >
                    <CredusText
                      size="md"
                      weight="bold"
                      color={el.active ? color.primary : ''}
                    >
                      {el?.name}
                    </CredusText>
                  </TitleDiv>
                ))}
              </Div>
            </TabDiv>
            {createTest ? (
              <CreateTestModal
                createTest={createTest}
                setCreateTest={setCreateTest}
                setTestReUpload={setTestReUpload}
              />
            ) : (
              <TestData setCreateTest={setCreateTest} />
            )}
          </>
        )}
      </div>
    </TestProvider>
  );
};

export default TestUpload;

const TabDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 7rem;
`;

const Div = styled.div`
  display: flex;
  gap: 2rem;
`;

const TitleDiv = styled.div<TitleDivProps>`
  padding: 2px;
  padding-bottom: 1rem;
  cursor: pointer;
  border-bottom: ${({ active }) =>
    active ? '3px solid' + color.primary : 'none'};
`;
